import type { InjectionKey } from 'vue'
import type { BlockContext } from './block'

export const BLOCK_CONTEXT_INJECTION_KEY = Symbol() as InjectionKey<BlockContext>
